import { Validators } from '@angular/forms';
import { PolluxFormConfig } from '../../../../../components/common/pollux-form-config/pollux-form-config';
export const leasesFormConfig: PolluxFormConfig[] = [
  {
    name: 'oid',
    value: 'oid',
    disabled: true
  },
  {
    name: 'CreatedDate',
    value: 'CreatedDate',
    isDate: true,
    disabled: true
  },
  {
    name: 'ModifiedDate',
    value: 'ModifiedDate',
    isDate: true,
    disabled: true
  },
  {
    name: 'OwnerUserID',
    value: 'OwnerUserID',
    disabled: true
  },
  {
    name: 'ModifiedByUserId',
    value: 'ModifiedByUserId',
    disabled: true
  },
  {
    name: 'OwnerBuID',
    value: 'OwnerBuID',
    disabled: true
  },
  {
    name: 'ModifiedBuID',
    value: 'ModifiedBuID',
    disabled: true
  },
  {
    name: 'BuildingName',
    value: 'BuildingName',
    disabled: true
  },
  {
    name: 'PrimaryUse',
    value: 'PrimaryUse'
  },
  {
    name: 'StreetName',
    value: 'StreetName',
    disabled: true
  },
  {
    name: 'NumberFrom',
    value: 'NumberFrom',
    disabled: true
  },
  {
    name: 'NumberTo',
    value: 'NumberTo',
    disabled: true
  },
  {
    name: 'NumberAdd',
    value: 'NumberAdd',
    disabled: true
  },
  {
    name: 'ZipCode6',
    value: 'ZipCode6',
    disabled: true
  },
  {
    name: 'City',
    value: 'City',
    disabled: true
  },
  {
    name: 'Region',
    value: 'Region'
  },
  {
    name: 'SubMarket',
    value: 'SubMarket',
    disabled: true
  },
  {
    name: 'Country',
    value: 'Country',
    disabled: true
  },
  {
    name: 'ConstructionYear',
    value: 'ConstructionYear',
    disabled: true
  },
  {
    name: 'RenovationYear',
    value: 'RenovationYear',
    disabled: true
  },
  {
    name: 'energyLabelDescription',
    value: 'energyLabelDescription',
    disabled: true
  }, 
  {
    name: 'filledOnSave',
    fixedValue: 'Filled on save',
    disabled: true
  },
  {
    name: 'currencyId',
    value: 'currencyId',
    validators: [Validators.min(1)]
  },
  {
    name: 'unitOfLengthId',
    value: 'unitOfLengthId',
    validators: [Validators.min(1)]
  },
  {
    name: 'CapitalisationGroup',
    value: 'CapitalisationGroup'
  },
  {
    name: 'CostDeductions',
    value: 'CostDeductions'
  },
  {
    name: 'PercentErvUpliftPerTotalRent',
    value: 'PercentErvUpliftPerTotalRent'
  },
  {
    name: 'PercentErvUpliftPerRent',
    value: 'PercentErvUpliftPerRent'
  },
  {
    name: 'ReversionYield',
    value: 'ReversionYield'
  },
  {
    name: 'DcfExitYld',
    value: 'DcfExitYld'
  },
  {
    name: 'FrothYield',
    value: 'FrothYield'
  },
  {
    name: 'HardcoreYield',
    value: 'HardcoreYield'
  },
  {
    name: 'DeemedRent',
    value: 'DeemedRent'
  },
  {
    name: 'GrossValue',
    value: 'GrossValue'
  },
  {
    name: 'VacantPeriod',
    value: 'VacantPeriod'
  },
  {
    name: 'ErvVacancyLoss',
    value: 'ErvVacancyLoss'
  },
  {
    name: 'PercentErvVacancyLoss',
    value: 'PercentErvVacancyLoss'
  },
  {
    name: 'Froth',
    value: 'Froth'
  },
  {
    name: 'PercentFroth',
    value: 'PercentFroth'
  },
  {
    name: 'ErvVoidLoss',
    value: 'ErvVoidLoss'
  },
  {
    name: 'EffectiveBreak',
    value: 'EffectiveBreak',
    isDate: true
  },
  {
    name: 'EarliestTermination',
    value: 'EarliestTermination',
    isDate: true
  },
  {
    name: 'LeaseStart',
    value: 'LeaseStart',
    isDate: true
  },  
  {
    name: 'NextReview',
    value: 'NextReview',
    isDate: true
  },
  {
    name: 'LeaseExpiry',
    value: 'LeaseExpiry',
    isDate: true,
  },
  {
    name: 'AreaSqft',
    value: 'AreaSqft'
  },
  {
    name: 'PeriodToBreak',
    value: 'PeriodToBreak'
  },
  {
    name: 'RentFreePeriod',
    value: 'RentFreePeriod'
  },
  {
    name: 'UnitDescription',
    value: 'UnitDescription'
  },
  {
    name: 'PropertyPrimaryUse',
    value: 'PrimaryUse',
    disabled: true
  },
  {
    name: 'Status',
    value: 'Status'
  },
  {
    name: 'LeaseType',
    value: 'LeaseType'
  },
  {
    name: 'PropertyRegion',
    value: 'Region',
    disabled: true
  },
  {
    name: 'Sector',
    value: 'Sector'
  },
  {
    name: 'LeaseName',
    value: 'LeaseName'
  },
  {
    name: 'TenantFileRefNo',
    value: 'TenantFileRefNo'
  },
  {
    name: 'TenantUse',
    value: 'TenantUse'
  },
  {
    name: 'Covenant',
    value: 'Covenant'
  },
  {
    name: 'ValuationMethod',
    value: 'ValuationMethod'
  },
  {
    name: 'PeriodToExpiry',
    value: 'PeriodToExpiry'
  },
  {
    name: 'BreakType',
    value: 'BreakType'
  },
  {
    name: 'PeriodToTermination',
    value: 'PeriodToTermination'
  },
  {
    name: 'VoidExpiryByBreak',
    value: 'VoidExpiryByBreak'
  },
  {
    name: 'GroundRent',
    value: 'GroundRent'
  },
  {
    name: 'ContractedRent',
    value: 'ContractedRent'
  },
  {
    name: 'RentalValue',
    value: 'RentalValue'
  },
  {
    name: 'ErvRatePerSqft',
    value: 'ErvRatePerSqft'
  },
  {
    name: 'RentRatePerSqft',
    value: 'RentRatePerSqft'
  },
  {
    name: 'PercentErv',
    value: 'PercentErv'
  },
  {
    name: 'PercentRent',
    value: 'PercentRent'
  },
  {
    name: 'ErvUplift',
    value: 'ErvUplift'
  },
  {
    name: 'ProjectPuid',
    value: 'ProjectPuid',
    disabled: true
  },
  {
    name: 'ValuationId',
    value: 'ValuationId',
    disabled: true
  },
  {
    name: 'PropertyId',
    value: 'PropertyId'
  },
  {
    //required for Project retriever
    name: 'ProjectPuidDescription',
    value: 'ProjectPuidDescription',
    disabled: true
  },
  {
    //required for ValuationPortfolio retriever
    name: 'ValuationIdDescription',
    value: 'ValuationIdDescription',
    disabled: true
  },
  {
    //required for Property retriever
    name: 'PropertyIdDescription',
    value: 'PropertyIdDescription',
    disabled: true
  },
  {
    name: 'filledWithProperty',
    fixedValue: 'Filled with Property...',
    disabled: true
  }
];
